export default {
      id: "icon-arrow-footer-usage",
      viewBox: "0 0 8.5 5.38",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-arrow-footer",
      toString: function () {
        return this.url;
      }
    }